export default {"src":"/_next/static/media/check.cfbec778.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};